import { useRef, useState, useEffect } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import "./scroll-animation.css";

const ScrollMask = () => {
  const ref = useRef(null);
  const videoRef = useRef<HTMLVideoElement>(null);
  // Initialize mobile state immediately based on detection
  const [isMobile, setIsMobile] = useState(() => {
    if (typeof window !== 'undefined') {
      return window.innerWidth <= 768 || /Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    }
    return false;
  });
  
  // Detect mobile device
  useEffect(() => {
    const checkMobile = () => {
      const mobile = window.innerWidth <= 768 || /Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
      console.log('Mobile detection:', { 
        width: window.innerWidth, 
        userAgent: navigator.userAgent,
        isMobile: mobile 
      });
      setIsMobile(mobile);
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);
  
  // Force video reload when mobile state changes
  useEffect(() => {
    if (videoRef.current) {
      console.log('Reloading video for mobile state:', isMobile);
      console.log('Video source being used:', isMobile ? "/logobackground.mobile.webm" : "/logobackground.webm");
      videoRef.current.load();
    }
  }, [isMobile]);
  
  const { scrollYProgress } = useScroll({
    target: ref,
  });
  const scale = useTransform(scrollYProgress, [0, 1], [15, 1]);
  const opacity = useTransform(scrollYProgress, [0.2, 0.45], [0, 1]);

  return (
    <div ref={ref} className="scroll-mask-container">
      <div className="scroll-content">
        {/* Video background - responsive source */}
        <video 
          ref={videoRef}
          key={isMobile ? "mobile" : "desktop"}
          className="background-video"
          autoPlay 
          muted 
          loop 
          playsInline
          preload={isMobile ? "none" : "metadata"}
        >
          <source 
            src={isMobile ? "/logobackground.mobile.webm" : "/logobackground.webm"} 
            type="video/webm" 
          />
          <track kind="captions" src="/captions/logobackground.vtt" srcLang="ro" label="Romanian" />
        </video>
  
        {/* Colored mask instead of transparent */}
        <motion.div
          style={{
            opacity: opacity,
            scale: scale,
          }}
          className="colored-mask"
        />
      </div>
    </div>
  );
};

export default ScrollMask;